import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { isAdminEmail } from '../adminEmails';
import { claritySet } from '../analytics';

// Human-friendly labels for the routes we care about; unknown paths fall through as-is.
const PAGE_LABELS = {
  '/submit': 'submit',
  '/wins': 'wins',
  '/admin': 'admin',
};

// Sets Microsoft Clarity custom tags so sessions can be segmented by user role and
// page. Renders nothing; must live inside both MsalProvider and the Router.
export default function ClarityTags() {
  const { accounts } = useMsal();
  const location = useLocation();
  const email = accounts[0]?.username?.toLowerCase() || '';

  // Role tag — set once we know who the user is.
  useEffect(() => {
    if (!email) return;
    claritySet('user_role', isAdminEmail(email) ? 'admin' : 'contributor');
  }, [email]);

  // Page tag — re-set on every route change (Clarity doesn't segment SPA routes itself).
  useEffect(() => {
    claritySet('page', PAGE_LABELS[location.pathname] || location.pathname);
  }, [location.pathname]);

  return null;
}
